/**
 * @fileoverview SpeechAlarmComponent - 語音提醒元件
 * @description
 * 此元件提供定時語音提醒功能，可設定定時提示、自動報時等功能。
 * 支援 Web Speech API 和 Azure 語音服務，適用於需要語音提示的應用場景。
 *
 * @author JK Team
 * @version 1.0.0
 */
import { Component, inject, Input, OnInit, ViewChild, input, ChangeDetectionStrategy } from '@angular/core';
import { delay, interval } from 'rxjs';
import { AzureEnvironment, GoogleSpeechService, JkBaseComponent, PageKind } from 'jk-service';
import { JkgridwinComponent } from '../jkgridwin/jkgridwin.component';
import { StockTimeService } from 'jk-service';
import { jkLib } from 'jk-service';
import { webSpeechClass } from 'jk-service';
import { idNameItem } from 'jk-service';
import { AudioService } from 'jk-service';
import { mp3_pristine } from 'jk-service';
import { GridInitOption } from 'jk-service';
import { JkcheckboxComponent } from 'jk-service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


/**
 * @component SpeechAlarmComponent
 * @description
 * 語音提醒元件，提供定時語音提示功能。
 * 此元件可根據設定的時間表提供語音提醒，支援上班模式和假日模式，
 * 並可自動偵測銀行假日。同時支援 Web Speech API 和 Azure 語音服務。
 * @extends {JkBaseComponent}
 */
@Component({
  selector: 'app-speech-alarm',
  standalone: true,
  imports: [JkcheckboxComponent, JkgridwinComponent],
  templateUrl: './speech-alarm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./speech-alarm.component.scss'],
})
export class SpeechAlarmComponent extends JkBaseComponent implements OnInit {
  private stockTime = inject(StockTimeService);
  tts = inject(GoogleSpeechService);

  date1: string = jkLib.nowDate();
  // TODO: Skipped for migration because:
  //  Your application code writes to the query. This prevents migration.
  // TODO: Skipped for migration because:
  //  Your application code writes to the query. This prevents migration.
  // TODO: Skipped for migration because:
  //  Your application code writes to the query. This prevents migration.
  // TODO: Skipped for migration because:
  //  Your application code writes to the query. This prevents migration.
  @ViewChild('jkgrid') masterGrid!: JkgridwinComponent;
  webSpeech: webSpeechClass;
  voiceIndex: number = 21;
  scheduleMessage: string = '無資料';
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  is15minuteAlert: boolean = true;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  isSpeechAlarm: boolean = true;
  old15Min!: string; // 舊15分鐘.預防多次
  clockTime!: string;
  readonly promptPerior = input<number>(5); // 提示音間格秒數
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  modeIndex: number = 0; // 0:上班 1:假日
  readonly googleApiKey = input<string>('');
  private dialogData = inject(MAT_DIALOG_DATA, { optional: true });  //@Input() azureEnv!:AzureEnvironment;
  //@Input()
  //azureEnv!:AzureEnvironment;
  //itemList: any[] = [];
  get itemList(): idNameItem[] {
    return this.masterGrid.itemList;
  }
  public nowTime!: string;
  public modes: string[] = ['上班', '假日'];
  oldME001A!: string;
  oldME001B!: string;
  //qryMaster: DsJckme;
  message: string = '無message資料';
  logMessage: string = '無logMessage資料';
  isAzureSpeech: boolean = true;
  //az: jkAzureClass  = new jkAzureClass();
  constructor() {
    super();
    this.webSpeech = new webSpeechClass(this.cdr);

    this.gridInitOpt = {
      pageKind: PageKind.base, programId: '',
      sortField: '時間',
      sort: 'asc',
      defaultSort: null
    };

  }
  onNgInit() {

  }
  override async ngAfterViewInit(): Promise<void> {
    super.ngAfterViewInit();
    await this.queryData();

    this.voiceIndex = this.webSpeech.language2VoiceIndex('zh-TW');// prompt("Please enter a string:");
    //alert('speech-alarm voiceIndex='+this.voiceIndex);
    this.doTimer();
    const apiKey = this.dialogData?.googleApiKey ?? this.googleApiKey();
    this.tts.setApiKey(apiKey);

    this.cdr.markForCheck();
  }
  /*
  speechTTS(message: string) {
    //const ret = new jkRestReturnClass();
    if (!message) return;
    if (message === '') return;
    //console.log('speechTTS message:' + message);
    this.az.speechTTS(message, this.ret);
    //this.az.azure_pubpublish(pubsub_opt,message);
    if (this.ret.result) {
      this.myMessage(this.ret.getResult());
    }
    this.myMessage(message);
  }*/
  async queryData() {
    /*let showList = [];
    for (let i = 0; i < this.itemList.length; i++) {// Jckme
      let item = {
        時間: this.itemList[i].ME001,
        內容: this.itemList[i].ME003,
      };
      showList.push(item);
    }
    this.showItemList(showList, { 時間: '時間', 內容: '內容' });*/
    let where = '';
    let isHoliday = await this.stockTime.isBankHoliday(jkLib.nowDate());
    if (isHoliday)
      this.modeIndex = 1
    else
      this.modeIndex = 0;
    this.cdr.markForCheck();
    this.masterGrid.doQuery2('JCKME', 'S01', 'S', where, '', [this.modes[this.modeIndex]]);

  }
  myMessage(msg: string) {
    this.message = msg;
    this.logMessage = jkLib.nowTime8() + ' ' + msg + '\n' + this.logMessage;
    //this.logMessage = '<div>'+jkLib.nowTime8() + '</div> ' + msg + '<br>' + this.logMessage;
  }
  async myBeep(count: number) {
    for (let i = 0; i < count; i++) {
      const audio = new AudioService();
      audio.play(mp3_pristine);
    }
  }
  /*mySpeakText(msg: string){
    if(this.isAzureSpeech){
      //this.az.speakText(msg);
    }else
    this.webSpeech.speakText(msg, this.voiceIndex, 1);
  }*/

  async myWebSpeech(isMusic: boolean, message: string) {
    if (!message) return;
    if (message === '') return;
    if (isMusic) {
      await this.myBeep(1);
      await delay(1000);
    }
    //  this.webSpeech.speakText(message, this.voiceIndex, 1);
    //this.az.azure_pubpublish(pubsub_opt,message);
    //this.mySpeakText(message);
    this.tts.textToSpeech(message).subscribe({
      next: (result) => this.playAudio(result),
      error: (err) => console.error('Error during TTS:', err)
    });
    this.myMessage(message);
  }
  doTimer() {
    // This could be any observable stream
    const timer1 = interval(1000);
    //const timer5 = interval(5*60*1000); //  每五分鐘
    const timer15 = interval(15 * 60 * 1000); //  每15分鐘
    //const timer60 = interval(60*60*1000); //  每60分鐘

    const result = timer1
      .pipe
      //takeUntil(timer(startOfNextMinute))
      ()
      .subscribe((e: any) => {
        const currentDate = new Date();
        this.clockTime = currentDate.toLocaleTimeString();

        this.nowTime = jkLib.nowTime7();
        this.doCheckAlarm(this.nowTime);
        this.cdr.markForCheck();
      });

    const min15 = timer15.subscribe((e: any) => {
      this.do15MinuteBeep();
    });
  }
  do15MinuteBeep() {
    const now = new Date();
    let hh = now.getHours();
    let mm = now.getMinutes();
    let ss = now.getSeconds();

    if (this.is15minuteAlert) {
      let n = mm % 15;
      if (n === 14 && ss > 40 && hh >= 9) {
        let new15Min = jkLib.nowTime5();
        if (new15Min !== this.old15Min) {
          this.old15Min = new15Min;
          this.cdr.markForCheck();
          this.myBeep(1);
          delay(2000);
          this.myBeep(1);
        }
      }
    }
  }
  async doCheckAlarm(myTime: string) {
    if (!this.itemList) {
      return;
    }
    if (this.date1 !== jkLib.nowDate()) {
      this.date1 = jkLib.nowDate();
      await this.queryData();
    }
    /*if(this.itemList.length===0){
      this.queryData();
    }*/
    let me001 = myTime.substring(0, 5);
    let s = myTime.substring(7, 8);
    let sec = Number(s);
    let r: idNameItem | undefined = this.itemList.find((item: idNameItem) => {
      if (item.id === me001) {
        if (this.oldME001A === me001 && this.oldME001B === me001) {
          return undefined;
        }
        if (this.oldME001A === me001 && this.oldME001B !== me001 && sec < 30) {
          return undefined;
        }
        if (this.oldME001A === me001) {
          // 第二次
          this.oldME001B = this.oldME001A;
        }
        this.oldME001A = me001;

        return item;
      }
      return undefined;
    });
    if (r) {
      if (r.ps1 === '') {
        //this.speechTTS(r.ME003);
        await this.myWebSpeech(true, r.name);
        this.scheduleMessage = r.name;
      } else {
        await this.myWebSpeech(true, r.name);
        this.scheduleMessage = r.name;
      }
    }
  }
  gridInitOpt: GridInitOption;
  afterGridReady($event: JkgridwinComponent) {
    this.masterGrid = $event;
    this.masterGrid.gridSrv.init(this.gridInitOpt);
  }
  showItemList(itemList: any, columnLabel: any) {
    //this.masterGrid.open('明細', itemList, columnLabel);
    //this.masterGrid.itemList = itemList;
    //this.masterGrid.columnLabel = columnLabel;
    let where = ' 1=1';
    this.masterGrid.doQuery2('JCKME', 'S01', 'S', where, '', [this.modes[this.modeIndex]]);

  }
}
